module.exports = __webpack_public_path__ + "img/chevron-left.dc880f17.svg";